// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { ticketSchema } from '@/ticket/api/types';
import { z } from 'zod';

const ticketResponseSchema = z.object({
  data: z.array(ticketSchema),
});

/**
 * Get tickets associated with a specific asset
 * @param assetKey - The key of the asset to get tickets for
 * @returns An array of tickets associated with the asset
 */
export async function getAssetTickets(assetKey: string) {
  const url = `/v1/tickets-for-asset/${assetKey}`;
  const response = await api.get(url);

  const data = await parseResponse(ticketResponseSchema, response.data, {
    schemaName: 'AssetTickets',
    endpoint: url,
  });
  return data.data;
}
